/* eslint-disable prettier/prettier */
// Services
import RecursosPropriosService from "./RecursosPropriosService";
import UnimedService from "@/shared/services/UnimedService";

// Mixin padrão para a tabela
import TabelaMixin from "@/shared/mixin/TabelaMixin";

import {
  enumStatusPrestador,
  enumStatusPrestadorNome,
  EnumPerfis
} from "../../../shared/helpers/Enum";

export default {
  name: "recursos-proprios",
  mixins: [RecursosPropriosService, TabelaMixin, UnimedService],
  data() {
    return {
      listaStatus: [],
      listaTipos: [],
      listaRedes: [],
      listaUnimedOrigem: [],
      limparUnimed: false,
      campoPesquisa: "",
      objetoFiltroLocal: {},
      cabecalho: [
        {
          texto: "Código",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "70px"
          },
          campoOrdenacao: "codigo"
        },
        {
          texto: "Nome do Prestador",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "245px"
          },
          campoOrdenacao: "nome"
        },
        {
          texto: "Tipo",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "60px"
          },
          campoOrdenacao: "tipoDescricao"
        },
        {
          texto: "CPF/CNPJ",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "130px"
          },
          campoOrdenacao: "cpfCnpj"
        },
        {
          texto: "Rede",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "60px"
          },
          campoOrdenacao: "tipoRede"
        },
        {
          texto: "Unimed origem",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "200px"
          },
          campoOrdenacao: "cdUnimed"
        },

        {
          texto: "Status",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "100px"
          },
          campoOrdenacao: "ordemStatus"
        }
      ]
    };
  },
  beforeMount() {
    this.init();
    this.$store.commit('setFetched', false);
    this.$store.commit('limparStore');
  },
  methods: {
    /**
     * Método inicial da página
     */
    init() {
      this.loadingTabela = true;
      this.inicializarRedes().finally(() => {
        this.inicializarStatus().finally(() => {
          this.inicializarTipos().finally(() => {
            this.inicializarUnimeds().finally(() => {
              this.inicializarOrdenacaoPadrao();
              this.inicializarFiltroPadrao();
            });
          });
        });
      });
    },
    /**
     * Método que faz a chamada na service para recuperar as linhas da tabela e outras informações adicionais
     */
    iniciarTabela() {
      this.loadingTabela = true;
      let tempObjetoTabela = this.objetoTabelaAtual();
      this.getTabelaRecursosProprios(tempObjetoTabela)
        .then(res => {
          this.configurarTabela(res.data, rows => {
            this.montarTabela(rows);
          });
        })
        .finally(() => {
          this.loadingTabela = false;
          this.iniciado = true;
        });
    },
    /**
     * Método para montar a tabela
     *  @param {Array} rows - linhas da tabela
     */
    montarTabela(rows) {
      this.rows = [];
      rows.forEach(e => {
        const {
          id,
          unimedOrigem,
          cpfCnpj,
          codigo,
          nome,
          tipo: { descricao: descricaoTipo },
          rede: { descricao: descricaoRede },
          status: { chave: statusChave, descricao: descricaoChave },
          dtExclusaoProgramada
        } = e;

        let objetoStatusTemp = enumStatusPrestador[statusChave];
        objetoStatusTemp.textoEstilo = descricaoChave;

        if (statusChave === enumStatusPrestadorNome.EXCLUSAO_PROGRAMADA) {
          objetoStatusTemp.textoEstilo = "Ativo";
          objetoStatusTemp.icones[0].tooltip = `Exclusão programada para ${this.$helpers.formatadorDataSafe(
            dtExclusaoProgramada,
            "L"
          )}`;
        }

        this.rows.push({
          codigo,
          nome: {
            texto: nome || " - ",
            qtdMaxCaracteres: 30,
            whiteSpaceNoWrap: false,
            larguraMaxima: 900,
            tooltipLocalizacao: "top"
          },
          tipo: descricaoTipo,
          documento: cpfCnpj,
          rede: descricaoRede,
          unimedOrigem,
          status: objetoStatusTemp,
          naoMostrar: {
            naoAparece: true,
            id
          }
        });
      });
      this.salvarFiltro();
    },
    /**
     * Limpa o objeto da pesquisa
     */
    limparPesquisa() {
      this.campoPesquisa = "";
    },
    /**
     * Método pra fazer a chamada para unimedOrigem vazia, logo após limpar o campo de pesquisa
     */
    limparCampoPesquisa() {
      this.limparPesquisa();
    },
    /**
     * Método que é chamado logo após feito o clique em uma das linhas
     * @param {Number} index - linha que foi feito o clique
     */
    clickLinha(index) {
      const { id } = this.rows[index].naoMostrar;
      const { tipo } = this.rows[index]
      if ([null, undefined, ""].includes(id)) return;
      const url = `${this.$options.name}/${id}/${this.criarUrlQuestionario(tipo)}`
      this.$router.push(url)
    },
    
    criarUrlQuestionario(tipoDescricao) {
      const tipoChave = this.listaTipos.filter(t => t.descricao == tipoDescricao)[0].chave.toLowerCase()
      return `questionario/${tipoChave}` 
    },

    pesquisarTabela() {
      this.$set(this.objetoTabela, "pagina", this.pagina);
      this.$set(this.objetoTabela, "busca", this.campoPesquisa);
      this.filtrar();
    },

    inicializarOrdenacaoPadrao() {
      this.objetoTabela.ordenacao = "ordemStatus";
      this.objetoTabela.direcao = "ASC";
    },

    inicializarFiltroPadrao() {
      const { chave } = this.papelUsuarioMixin;

      if (chave === EnumPerfis.SINGULAR) {
        const refFiltro = this.$refs["filtro"];

        refFiltro.setFiltro({
          ...refFiltro.objetoFiltroVazio,
          unimedOrigem: {
            chave: "",
            descricao:
              this.codigoUnimedUsuarioMixin +
              " - " +
              this.unimedSelecionadaNomeMixin
          }
        });
        this.$nextTick(() => {
          refFiltro.filtrar();
        });
        return;
      }

      this.iniciarTabela();
    },

    inicializarAnalistas() {
      return new Promise((resolve, reject) => {
        this.getAnalistas()
          .then(res => {
            this.listaAnalistas = res.data;
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    inicializarRedes() {
      return new Promise((resolve, reject) => {
        this.getRedes()
          .then(res => {
            this.listaRedes = res.data;
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    inicializarStatus() {
      return new Promise((resolve, reject) => {
        this.getStatus()
          .then(res => {
            this.listaStatus = res.data;
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    inicializarTipos() {
      return new Promise((resolve, reject) => {
        this.getTipos()
          .then(res => {
            this.listaTipos = res.data;
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    inicializarUnimeds() {
      return new Promise((resolve, reject) => {
        this.getAllUnimeds()
          .then(res => {
            this.listaUnimedOrigem = res.data;
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    }
  }
};
